import { Button } from '@any-ui-react/core';
import { useModals } from '@any-ui-react/modals';
import { v4 as uuid } from 'uuid';

import { ModalFooter } from '@/common/components/shared/modal-footer/ModalFooter';

export const discardModalId = uuid();

export const useDiscardChangesModal = () => {
  const modalId = discardModalId;
  const { openModal, closeModal } = useModals();

  const openDiscardChangesModal = ({ onSuccess }: { onSuccess: () => void }) => {
    openModal({
      modalId,
      title: 'Discard Unsaved Changes',
      centered: true,
      size: 'lg',
      children: (
        <div>
          <span>The process cannot be undone</span>
          <ModalFooter>
            <Button
              variant="default"
              onClick={() => {
                closeModal(modalId);
              }}
            >
              Cancel
            </Button>
            <Button
              className="bg-failure hover:bg-failure"
              type="submit"
              onClick={() => {
                onSuccess();
                closeModal(modalId);
              }}
            >
              Discard
            </Button>
          </ModalFooter>
        </div>
      ),
    });
  };

  return { openDiscardChangesModal };
};
